import Component from 'can/component/component';
import template from './animation-preloader.stache';

Component.extend({
    tag: 'animation-preloader',
    template: template,
    viewModel: {},
});
